import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from 'vuex-persistedstate';
Vue.use(Vuex);

export default new Vuex.Store({
  plugins:[createPersistedState()],
  state: {
    currentPage: "home",
    pageBackground: "",
    activePanel: {
      _id: "",
      name: {
        type: String,
        default: ""
      },
      alias: {
        type: String,
        default: ""
      },
      logo: {
        type: String,
        default: ""
      },
      background: {
        type: String,
        default: ""
      },
      dep: {
        type: Array,
        default: []
      },
    },
    guest: {
      _id: "",
      name: "",
      photo: {
        _id: "",
        path: ""
      }
    },
    company: {
      _id: 0
    },
    appRestart: false,
    auth:false,
    ident_totem:"",
    depSelect:null,
    messsage:{},
    photo:null,
    schedule: {
        type: Object,
        default: {
          company: {},
          department: {},
          reason: '',
          name: '',
          photo: '',
        }
      },
      qrcodeSchedule: {},
    showKeyboard: false,
    isLoading: false,
  },
  getters: {
    getAppRestart: ({ appRestart }) => {
      return appRestart;
    },
    getCurrentPage: ({ currentPage }) => {
      return currentPage;
    },
    getPageBackground: ({ pageBackground }) => {
      return pageBackground;
    },
    getActivePanel: ({ activePanel }) => {
      return activePanel;
    },
    getCompany: ({ company }) => {
      return company;
    },
    getSchedule: ({ schedule }) => {
      return schedule;
    },
    getKeyboardStatus: ({ showKeyboard }) => {
      return showKeyboard;
    },
    getIsLoading: ({ isLoading }) => {
      return isLoading;
    }
  },
  mutations: {
    setAppRestart: (state, newStatus) => {
      state.appRestart = newStatus;
    },
    setCurrentPage: (state, newPage) => {
      state.currentPage = newPage;
    },
    setPageBackground: (state, newImage) => {
      state.pageBackground = newImage;
    },
    setActivePanel: (state, panelData) => {
      state.activePanel = panelData;
    },
    setCompany: (state, company) => {
      state.company = company;
    },
    setSessionTotem:(state, payload)=>{
      state.auth = true
      state.ident_totem = payload
    },
    setLogoffSessionTotem:(state)=>{
      state.auth = false
      state.ident_totem = ""
    },
    setDepsSelect:(state,payload)=>{
      state.depSelect = payload
    },
    setMessage:(state,payload)=>{
      state.messsage = payload
    },
    setPhoto:(state,payload)=>{
        state.photo = payload
    },
    setScheduleCompany:(state,payload)=>{
      state.schedule.company = payload
    },
    setScheduleDepartment:(state,payload)=>{
      state.schedule.department = payload
    },
    setScheduleReason:(state,payload)=>{
      state.schedule.reason = payload
    },
    setScheduleName:(state,payload)=>{
      state.schedule.name = payload
    },
    setSchedulePhoto:(state,payload)=>{
      state.schedule.photo = payload
    },
    setQrCodeSchedule:(state,payload)=>{
      state.qrcodeSchedule = payload
    },
    setAuth: (state, payload) => {
      state.auth = payload;
    },
    setKeyboardStatus: (state, payload) => {
      state.showKeyboard = payload;
    },
    setIsLoading: (state, payload) => {
      state.isLoading = payload;
    },
    toggleLoading: (state) => {
      state.isLoading = !state.isLoading;
    }
  },
  actions: {}
});
